// Fixed-order categorical palette (blue, orange, aqua, yellow, magenta, green,
// violet, red) validated for adjacent-pair colorblind + normal-vision
// separation on a light chart surface. Assign in this order, never cycle
// arbitrarily, so neighboring stack/bar segments stay distinguishable.
export const CATEGORICAL_PALETTE = [
  "#2a78d6",
  "#eb6834",
  "#1baf7a",
  "#eda100",
  "#e87ba4",
  "#008300",
  "#4a3aa7",
  "#e34948",
];

function lighten(hex, amount) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const mix = (c) => Math.round(c + (255 - c) * amount);
  return `#${[mix(r), mix(g), mix(b)]
    .map((c) => c.toString(16).padStart(2, "0"))
    .join("")}`;
}

// Once every hue in the fixed palette is used, wrapping around would repeat
// a color exactly. Instead lighten each additional lap so a sport count past
// 8 (real for this event, e.g. a bonus "Aloituspisteet" sport on top of a
// full day's games) still gets a color no other sport already has.
export function getSeriesColor(index) {
  const base = CATEGORICAL_PALETTE[index % CATEGORICAL_PALETTE.length];
  const lap = Math.floor(index / CATEGORICAL_PALETTE.length);
  if (lap === 0) return base;
  return lighten(base, Math.min(0.3 * lap, 0.75));
}
